module.exports = __webpack_public_path__ + "img/sy.26639d73.svg";